import React from 'react';
import { enumParser, ShelfTypeFilterEnum } from '@soundxyz/utils/const';
import { Chip } from '@components/main-components/elements/chips/Chip';
import { ParamsStore, useParams } from '@context/params';
import { useSafeLayoutEffect } from '@hooks/useSafeLayoutEffect';

const shelfEnumParser = enumParser(ShelfTypeFilterEnum);

export const PlaylistFilters = ({
  playlistsType,
  onClick: resetCb,
}: {
  playlistsType: ShelfTypeFilterEnum;
  onClick: (type: ShelfTypeFilterEnum) => void;
}) => {
  const { playlistFilter } = useParams();
  const windowQueryFilter = React.useMemo(() => {
    const filter = playlistFilter?.toUpperCase();
    if (!filter) return null;

    try {
      return shelfEnumParser(filter);
    } catch {
      return null;
    }
  }, [playlistFilter]);

  useSafeLayoutEffect(() => {
    if (windowQueryFilter && windowQueryFilter !== ShelfTypeFilterEnum.ALL) {
      onClick({ type: windowQueryFilter });
    } else {
      ParamsStore.playlistFilter = null;
    }
  }, [windowQueryFilter]);

  const onClick = ({ type }: { type: ShelfTypeFilterEnum }) => {
    // Don't refetch if the same type is selected
    if (playlistsType === type) return;

    if (type === 'ALL') {
      ParamsStore.playlistFilter = null;
    } else {
      ParamsStore.playlistFilter = type.toLowerCase();
    }

    resetCb(type);
  };

  return (
    <div className="flex gap-2">
      <Chip
        text="All"
        isSelected={playlistsType === ShelfTypeFilterEnum.ALL}
        onClick={() => onClick({ type: ShelfTypeFilterEnum.ALL })}
      />
      <Chip
        text="Created"
        isSelected={playlistsType === ShelfTypeFilterEnum.USER_CREATED}
        onClick={() => onClick({ type: ShelfTypeFilterEnum.USER_CREATED })}
      />
      <Chip
        text="Liked"
        isSelected={playlistsType === ShelfTypeFilterEnum.LIKED}
        onClick={() => onClick({ type: ShelfTypeFilterEnum.LIKED })}
      />
    </div>
  );
};
